<template>
  <div class="lotti-app" :class="isSigninRoute()">

    <navigation></navigation>

    <div class="lotti-container">
      <div class="lotti-content">
        <router-view></router-view>
      </div>
    </div>

    <page-footer></page-footer>

  </div>
</template>

<script>
import Navigation from './pageLayout/Navigation.vue'
import Footer from './pageLayout/Footer.vue'
import auth from "../auth";

export default {
  data() {
    return {}
  },
  methods: {
    isSigninRoute() {
      return this.$route.name === 'signin' ? 'lotti-app-signin-screen': '';
    },
  },
  components: {
    'navigation': Navigation,
    'page-footer': Footer
  }
  // mounted: function () {
  //     this.$nextTick(function () {
  //         auth.check()
  //     })
  // }
}
</script>
